import { render, staticRenderFns } from "./detail-link.vue?vue&type=template&id=548754b0&scoped=true"
import script from "./detail-link.vue?vue&type=script&lang=js"
export * from "./detail-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548754b0",
  null
  
)

export default component.exports